(function () {
  'use strict';

  var DESKTOP_BREAKPOINT = 0;
  var SECTION_ID = 'collection-quick-add';
  var DEFAULT_SUBSCRIBE_DISCOUNT = 15;
  var MONEY_FALLBACK = '$' + '{{amount}}';

  var modal = null;
  var dialog = null;
  var contentEl = null;
  var triggerButton = null;
  var initialized = false;
  var focusableSelector =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var state = {
    product: null,
    purchaseType: 'onetime',
    variantId: null,
    quantity: 1,
    sellingPlanId: null,
    frequencyLabel: '',
    adding: false
  };

  function isDesktop() {
    return window.matchMedia('(min-width: ' + DESKTOP_BREAKPOINT + 'px)').matches;
  }

  function getMoneyFormat() {
    return (window.theme && window.theme.moneyFormat) || MONEY_FALLBACK;
  }

  function formatMoney(cents) {
    if (window.RedmondMoney && typeof window.RedmondMoney.format === 'function') {
      return window.RedmondMoney.format(cents);
    }
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, getMoneyFormat());
    }
    return (Number(cents || 0) / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: (window.theme && window.theme.currencyCode) || 'USD'
    });
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getAllSellingPlans(product) {
    var plans = [];
    (product.selling_plan_groups || []).forEach(function (group) {
      (group.selling_plans || []).forEach(function (plan) {
        plans.push(plan);
      });
    });
    return plans;
  }

  function parseWeeksFromPlanName(name) {
    var match = String(name || '').match(/(\d+)\s*week/i);
    return match ? parseInt(match[1], 10) : null;
  }

  function getDiscountPercent(plan) {
    if (!plan || !plan.price_adjustments || !plan.price_adjustments.length) {
      return DEFAULT_SUBSCRIBE_DISCOUNT;
    }
    var adj = plan.price_adjustments[0];
    if (adj.value_type === 'percentage') return adj.value;
    return DEFAULT_SUBSCRIBE_DISCOUNT;
  }

  function getVariantById(product, variantId) {
    return (product.variants || []).find(function (v) {
      return String(v.id) === String(variantId);
    });
  }

  function getFirstAvailableVariant(product) {
    return (
      (product.variants || []).find(function (v) {
        return v.available;
      }) ||
      product.variants[0] ||
      null
    );
  }

  function getSelectedVariant(product) {
    return getVariantById(product, state.variantId) || getFirstAvailableVariant(product);
  }

  function getSelectedPlan(product) {
    return getAllSellingPlans(product).find(function (plan) {
      return String(plan.id) === String(state.sellingPlanId);
    });
  }

  function calcOneTimeTotal(variant, quantity) {
    return variant.price * quantity;
  }

  function calcSubscribeTotal(variant, quantity, plan) {
    var pct = getDiscountPercent(plan);
    var unit = Math.round((variant.price * (100 - pct)) / 100);
    return unit * quantity;
  }

  function buildFrequencyOptions(product) {
    var plans = getAllSellingPlans(product);
    var seen = {};
    var options = [];

    plans.forEach(function (plan) {
      var weeks = parseWeeksFromPlanName(plan.name);
      var key = weeks ? String(weeks) : plan.name;
      if (seen[key]) return;
      seen[key] = true;
      options.push({
        planId: plan.id,
        weeks: weeks,
        label: weeks ? weeks + ' weeks' : plan.name
      });
    });

    options.sort(function (a, b) {
      if (a.weeks && b.weeks) return a.weeks - b.weeks;
      if (a.weeks) return -1;
      if (b.weeks) return 1;
      return a.label.localeCompare(b.label);
    });

    return options;
  }

  function initStateFromProduct(product) {
    var variant =
      getVariantById(product, product.default_variant_id) || getFirstAvailableVariant(product);
    var plans = getAllSellingPlans(product);
    var frequencyOptions = buildFrequencyOptions(product);

    state.product = product;
    state.variantId = variant ? variant.id : null;
    state.quantity = 1;
    state.adding = false;

    state.purchaseType = 'onetime';

    if (product.has_selling_plans && plans.length) {
      state.sellingPlanId = frequencyOptions.length
        ? frequencyOptions[0].planId
        : plans[0].id;
      state.frequencyLabel = frequencyOptions.length ? frequencyOptions[0].label : plans[0].name;
    } else {
      state.sellingPlanId = null;
      state.frequencyLabel = '';
    }
  }

  function getFocusableElements() {
    return Array.prototype.slice.call(dialog.querySelectorAll(focusableSelector)).filter(function (el) {
      return el.offsetParent !== null;
    });
  }

  function trapFocus(event) {
    if (!modal || !dialog || event.key !== 'Tab' || modal.hidden) return;
    var focusable = getFocusableElements();
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openModal() {
    if (!modal || !dialog) return;
    modal.hidden = false;
    modal.removeAttribute('hidden');
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('collection-quick-add-open');
    dialog.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeModal() {
    if (!modal || !contentEl) return;
    modal.hidden = true;
    modal.setAttribute('hidden', '');
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('collection-quick-add-open');
    contentEl.innerHTML =
      '<div class="collection-quick-add-modal__loading" aria-live="polite"><span class="collection-quick-add-modal__spinner"></span>Loading…</div>';
    document.removeEventListener('keydown', onKeydown);
    state.product = null;
    if (triggerButton) {
      triggerButton.focus();
      triggerButton = null;
    }
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }
    trapFocus(event);
  }

  function renderModal(product) {
    var variant = getSelectedVariant(product);
    var plans = getAllSellingPlans(product);
    var frequencyOptions = buildFrequencyOptions(product);
    var oneTimeTotal = variant ? calcOneTimeTotal(variant, state.quantity) : 0;
    var selectedPlan = getSelectedPlan(product);
    var subscribeTotal =
      variant && selectedPlan ? calcSubscribeTotal(variant, state.quantity, selectedPlan) : oneTimeTotal;
    var activeTotal = state.purchaseType === 'subscribe' ? subscribeTotal : oneTimeTotal;
    var savings = Math.max(0, oneTimeTotal - subscribeTotal);
    var discountPct = selectedPlan ? getDiscountPercent(selectedPlan) : DEFAULT_SUBSCRIBE_DISCOUNT;
    var flavorLabel = variant ? variant.title : product.title;
    var ctaLabel = '';

    if (!variant || !variant.available) {
      ctaLabel = 'Sold out';
    } else if (state.purchaseType === 'subscribe' && selectedPlan) {
      ctaLabel =
        'Subscribe - ' +
        formatMoney(subscribeTotal) +
        ' / ' +
        (state.frequencyLabel || selectedPlan.name);
    } else {
      ctaLabel = 'Add to cart - ' + formatMoney(oneTimeTotal);
    }

    var html = '<div class="collection-quick-add">';

    html += '<div class="collection-quick-add__header">';
    if (product.featured_image) {
      html +=
        '<div class="collection-quick-add__thumb"><img src="' +
        escapeHtml(product.featured_image) +
        '" alt="' +
        escapeHtml(product.featured_image_alt || product.title) +
        '"></div>';
    }
    html += '<div class="collection-quick-add__header-text">';
    html +=
      '<h2 class="collection-quick-add__title" id="CollectionQuickAddTitle">' +
      escapeHtml(product.title) +
      '</h2>';
    html +=
      '<a class="collection-quick-add__details-link" href="' +
      escapeHtml(product.url) +
      '">View Full Details</a>';
    html += '</div></div>';

    if (product.has_selling_plans && plans.length) {
      html += '<div class="collection-quick-add__section"><span class="collection-quick-add__label">Purchase type</span>';
      html += '<div class="collection-quick-add__purchase-types">';

      html +=
        '<label class="collection-quick-add__purchase-type' +
        (state.purchaseType === 'onetime' ? ' is-selected' : '') +
        '" data-purchase-type="onetime">';
      html += '<input type="radio" name="collection_quick_add_purchase" value="onetime"' +
        (state.purchaseType === 'onetime' ? ' checked' : '') +
        '>';
      html += '<span class="collection-quick-add__radio"></span>';
      html += '<span class="collection-quick-add__purchase-copy">';
      html += '<span class="collection-quick-add__purchase-title">Single purchase</span>';
      html +=
        '<span class="collection-quick-add__purchase-price">' +
        (variant ? formatMoney(variant.price) : '') +
        '</span>';
      html += '</span></label>';

      html +=
        '<label class="collection-quick-add__purchase-type' +
        (state.purchaseType === 'subscribe' ? ' is-selected' : '') +
        '" data-purchase-type="subscribe">';
      html += '<input type="radio" name="collection_quick_add_purchase" value="subscribe"' +
        (state.purchaseType === 'subscribe' ? ' checked' : '') +
        '>';
      html += '<span class="collection-quick-add__radio"></span>';
      html += '<span class="collection-quick-add__purchase-copy">';
      html +=
        '<span class="collection-quick-add__purchase-title">Subscribe &amp; save ' +
        discountPct +
        '%</span>';
      html += '<span class="collection-quick-add__purchase-price">';
      if (variant) {
        html += '<s>' + formatMoney(variant.price) + '</s>';
        html += formatMoney(Math.round((variant.price * (100 - discountPct)) / 100));
      }
      html += '</span></span></label>';
      html += '</div></div>';
    }

    if (product.has_multiple_variants && product.variants.length > 1) {
      html += '<div class="collection-quick-add__section"><span class="collection-quick-add__label">Select flavor</span>';
      html += '<div class="collection-quick-add__flavors">';
      product.variants.forEach(function (v) {
        var selected = String(v.id) === String(state.variantId);
        html +=
          '<label class="collection-quick-add__flavor' +
          (selected ? ' is-selected' : '') +
          (!v.available ? ' is-unavailable' : '') +
          '" data-variant-id="' +
          v.id +
          '">';
        html +=
          '<input type="radio" name="collection_quick_add_variant" value="' +
          v.id +
          '"' +
          (selected ? ' checked' : '') +
          (!v.available ? ' disabled' : '') +
          '>';
        html += '<span class="collection-quick-add__flavor-check" aria-hidden="true">✓</span>';
        html += '<span class="collection-quick-add__flavor-thumb">';
        if (v.featured_image) {
          html +=
            '<img src="' +
            escapeHtml(v.featured_image) +
            '" alt="' +
            escapeHtml(v.title) +
            '">';
        }
        html += '</span>';
        html += '<span class="collection-quick-add__flavor-name">' + escapeHtml(v.title) + '</span>';
        html += '</label>';
      });
      html += '</div></div>';
    }

    html += '<div class="collection-quick-add__section"><span class="collection-quick-add__label">Quantity</span>';
    html += '<div class="collection-quick-add__quantity">';
    html += '<button type="button" class="collection-quick-add__qty-btn" data-qty-change="-1" aria-label="Decrease quantity">−</button>';
    html +=
      '<input type="number" class="collection-quick-add__qty-input" min="1" value="' +
      state.quantity +
      '" aria-label="Quantity">';
    html += '<button type="button" class="collection-quick-add__qty-btn" data-qty-change="1" aria-label="Increase quantity">+</button>';
    html += '</div></div>';

    if (product.has_selling_plans && plans.length && state.purchaseType === 'subscribe') {
      html += '<div class="collection-quick-add__section" data-frequency-section>';
      html += '<p class="collection-quick-add__frequency-label">Deliver every:</p>';
      html += '<div class="collection-quick-add__frequency-pills">';
      frequencyOptions.forEach(function (option) {
        var active = String(option.planId) === String(state.sellingPlanId);
        html +=
          '<button type="button" class="collection-quick-add__frequency-pill' +
          (active ? ' is-active' : '') +
          '" data-plan-id="' +
          option.planId +
          '" data-frequency-label="' +
          escapeHtml(option.label) +
          '">' +
          escapeHtml(option.label) +
          '</button>';
      });
      html += '</div></div>';
    }

    html += '<div class="collection-quick-add__summary">';
    html += '<div class="collection-quick-add__summary-row">';
    html += '<span class="collection-quick-add__summary-flavor">' + escapeHtml(flavorLabel) + '</span>';
    html += '<span>Qty: ' + state.quantity + '</span>';
    html += '</div>';
    html += '<div class="collection-quick-add__summary-pricing">';
    html += '<div>';
    if (state.purchaseType === 'subscribe' && savings > 0) {
      html += '<span class="collection-quick-add__summary-compare">' + formatMoney(oneTimeTotal) + '</span> ';
    }
    html += '<span class="collection-quick-add__summary-total">' + formatMoney(activeTotal) + '</span>';
    html += '</div>';
    if (state.purchaseType === 'subscribe' && savings > 0) {
      html +=
        '<span class="collection-quick-add__savings">Save ' + formatMoney(savings) + '</span>';
    }
    html += '</div></div>';

    html += '<div class="collection-quick-add__cta-wrap">';
    html +=
      '<button type="button" class="collection-quick-add__cta"' +
      ' aria-disabled="false"' +
      ' aria-busy="' + (state.adding ? 'true' : 'false') + '"' +
      '>' +
      escapeHtml(state.adding ? 'Adding…' : ctaLabel) +
      '</button>';
    html += '</div>';

    html += '</div>';

    contentEl.innerHTML = html;
    var renderedCta = contentEl.querySelector('.collection-quick-add__cta');
    if (renderedCta) {
      renderedCta.disabled = false;
      renderedCta.removeAttribute('disabled');
      renderedCta.style.setProperty('cursor', 'pointer', 'important');
      renderedCta.style.setProperty('pointer-events', 'auto', 'important');
    }
    bindModalEvents(product);
  }

  function bindModalEvents(product) {
    contentEl.querySelectorAll('[data-purchase-type]').forEach(function (el) {
      el.addEventListener('click', function () {
        state.purchaseType = el.getAttribute('data-purchase-type');
        if (state.purchaseType === 'subscribe') {
          var options = buildFrequencyOptions(product);
          if (options.length) {
            state.sellingPlanId = options[0].planId;
            state.frequencyLabel = options[0].label;
          }
        } else {
          state.sellingPlanId = null;
          state.frequencyLabel = '';
        }
        renderModal(product);
      });
    });

    contentEl.querySelectorAll('[data-variant-id]').forEach(function (el) {
      el.addEventListener('click', function () {
        var variantId = el.getAttribute('data-variant-id');
        var variant = getVariantById(product, variantId);
        if (!variant || !variant.available) return;
        state.variantId = variant.id;
        renderModal(product);
      });
    });

    contentEl.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
        state.quantity = Math.max(1, state.quantity + delta);
        renderModal(product);
      });
    });

    var qtyInput = contentEl.querySelector('.collection-quick-add__qty-input');
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var value = parseInt(qtyInput.value, 10);
        state.quantity = isNaN(value) || value < 1 ? 1 : value;
        renderModal(product);
      });
    }

    contentEl.querySelectorAll('[data-plan-id]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        state.sellingPlanId = pill.getAttribute('data-plan-id');
        state.frequencyLabel = pill.getAttribute('data-frequency-label') || '';
        renderModal(product);
      });
    });

    var cta = contentEl.querySelector('.collection-quick-add__cta');
    if (cta) {
      cta.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        addToCart(product);
      }, true);
    }
  }

  function openCartDrawer() {
    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
      return;
    }
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
      window.Rebuy.SmartCart.show();
      return;
    }
    var trigger =
      document.querySelector('.mobile-cart-page-link') ||
      document.querySelector('.header-bar .cart-page-link') ||
      document.querySelector('.cart-page-link');
    if (trigger) {
      trigger.click();
      return;
    }
    window.location.href = '/cart';
  }

  function addToCart(product) {
    var variant = getSelectedVariant(product);
    if (!variant || !variant.available || state.adding) return;

    state.adding = true;
    renderModal(product);

    var cartAddUrl = window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js';
    var payload = {
      items: [{
        id: variant.id,
        quantity: state.quantity
      }]
    };
    if (state.purchaseType === 'subscribe' && state.sellingPlanId) {
      payload.items[0].selling_plan = state.sellingPlanId;
    }

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (response.ok) return response.json();

        // Keep compatibility with endpoints that only accept form data.
        var fallbackPayload = new URLSearchParams();
        fallbackPayload.set('id', String(variant.id));
        fallbackPayload.set('quantity', String(state.quantity));
        if (state.purchaseType === 'subscribe' && state.sellingPlanId) {
          fallbackPayload.set('selling_plan', String(state.sellingPlanId));
        }

        return fetch(cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: fallbackPayload
        }).then(function (fallbackResponse) {
          if (!fallbackResponse.ok) throw new Error('Add to cart failed');
          return fallbackResponse.json();
        });
      })
      .then(function () {
        closeModal();
        openCartDrawer();
      })
      .catch(function (error) {
        console.error('[Collection quick add]', error);
        state.adding = false;
        renderModal(product);
      });
  }

  function parseProductFromSectionHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var jsonEl = doc.getElementById('CollectionQuickAddData');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      console.error('[Collection quick add] invalid product JSON', error);
      return null;
    }
  }

  function fetchProductData(handle) {
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    var url = root + 'products/' + encodeURIComponent(handle) + '?section_id=' + SECTION_ID;

    return fetch(url, {
      headers: {
        Accept: 'text/html'
      }
    }).then(function (response) {
      if (!response.ok) throw new Error('Product fetch failed');
      return response.text();
    }).then(function (html) {
      var product = parseProductFromSectionHtml(html);
      if (!product) throw new Error('Missing product data');
      return product;
    });
  }

  function showLoading() {
    contentEl.innerHTML =
      '<div class="collection-quick-add-modal__loading" aria-live="polite"><span class="collection-quick-add-modal__spinner"></span>Loading…</div>';
  }

  function showError(message) {
    if (!contentEl) return;
    contentEl.innerHTML =
      '<div class="collection-quick-add-modal__loading" aria-live="polite">' +
      escapeHtml(message) +
      '</div>';
  }

  function handleCardClick(event) {
    if (event.defaultPrevented || event.button !== 0) return;

    var card = event.target.closest('.collection-product-card');
    if (!card) return;
    if (
      event.target.closest('.collection-product-card__quick-add') ||
      event.target.closest('.collection-product-card__view-product')
    ) {
      return;
    }

    var link = card.querySelector('.collection-product-card__stretched-link');
    if (!link || event.target.closest('a') === link) return;

    if (event.metaKey || event.ctrlKey) {
      window.open(link.href, '_blank', 'noopener');
      return;
    }

    window.location.href = link.href;
  }

  function handleQuickAddClick(event) {
    var button = event.target.closest('.collection-product-card__quick-add');
    if (!button) return;

    var productUrl = button.getAttribute('data-product-url');
    var handle = button.getAttribute('data-product-handle');

    if (!isDesktop()) {
      if (productUrl) window.location.href = productUrl;
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (!modal || !contentEl) {
      init();
    }

    if (!modal || !contentEl) {
      if (productUrl) window.location.href = productUrl;
      return;
    }

    triggerButton = button;
    showLoading();
    openModal();

    fetchProductData(handle)
      .then(function (product) {
        if (!product) throw new Error('Missing product data');
        initStateFromProduct(product);
        renderModal(product);
      })
      .catch(function (error) {
        console.error('[Collection quick add]', error);
        showError('Unable to load product details. Please try again.');
      });
  }

  function bindModalShellEvents() {
    if (!modal || initialized) return;
    initialized = true;

    modal.querySelectorAll('[data-quick-add-close]').forEach(function (closeTarget) {
      closeTarget.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeModal();
      }, true);
    });
  }

  function init() {
    modal = document.getElementById('CollectionQuickAddModal');
    if (!modal) return;

    dialog = modal.querySelector('.collection-quick-add-modal__dialog');
    contentEl = document.getElementById('CollectionQuickAddContent');
    bindModalShellEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('click', handleCardClick);
  document.addEventListener('click', handleQuickAddClick);
  function handleCtaPress(event) {
    if (!contentEl || !state.product || state.adding || event.button !== 0) return;

    var cta = contentEl.querySelector('.collection-quick-add__cta');
    if (!cta) return;

    var rect = cta.getBoundingClientRect();
    var isInsideCta =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;
    if (!isInsideCta) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart(state.product);
  }

  window.addEventListener('pointerdown', handleCtaPress, true);
  window.addEventListener('mousedown', handleCtaPress, true);
  window.addEventListener('pointerup', function (event) {
    if (!contentEl || !state.product || state.adding) return;

    var cta = contentEl.querySelector('.collection-quick-add__cta');
    if (!cta) return;

    var rect = cta.getBoundingClientRect();
    var isInsideCta =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;
    if (!isInsideCta) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart(state.product);
  }, true);
  document.addEventListener('click', function (event) {
    var cta = event.target.closest('.collection-quick-add__cta');
    if (!contentEl || !state.product) return;

    if (!cta || !contentEl.contains(cta)) {
      cta = contentEl.querySelector('.collection-quick-add__cta');
      if (!cta) return;

      var rect = cta.getBoundingClientRect();
      var isInsideCta =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;
      if (!isInsideCta) return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart(state.product);
  }, true);
})();
